import {useLocalSearchParams} from "expo-router";
import {MembershipPlanScreen} from "@/components/membership/MembershipPlanScreen";

export default function MembershipPlan() {
    const {orgId} = useLocalSearchParams<{orgId: string}>();
    return (
        <MembershipPlanScreen orgId={orgId} />
    );
}